<template>
    <div class="homeinterativa">
        <PageTitle icon="fas fa-tachometer-alt iconInterativoTitulo" main="Dashboard"
            sub="Painel Principal dos Serviços Hion" />
        <div class="stats">
            <Stat title="Frota e Equipamentos" :value="stat.maquinas"
                icon="fas fa-snowplow" color="#2e2d2c" />
            <Stat title="Baterias Inteligentes" :value="stat.baterias"
                icon="fas fa-car-battery" color="#ffd618" />
            <Stat title="Colaboradores" :value="stat.usuarios"
                icon="fas fa-id-card" color="#008fac" />
        </div>
    </div>
</template>

<script>
import PageTitle from '../PageTitle'
import Stat from './Stat'
import axios from 'axios'
import { mapState } from 'vuex'
import { baseApiUrl } from '@/global'

export default {
    name: 'HomeInterativa',
    components: { PageTitle, Stat },
    computed: mapState(['usuario']),
    data: function() {
        return {
            stat: {}
        }
    },
    methods: {
        getStats() {
            axios.get(`${baseApiUrl}/stats`).then(res => this.stat = res.data)
        },
        goBateriaInterativa() {
            this.$router.push({
                name: 'BateriaInterativa'
            })
        },
        goFrotaInterativa() {
            this.$router.push({
                name: 'FrotaInterativa'
            })
        },
        goColaboradorInterativo() {
            this.$router.push({
                name: 'ColaboradorInterativo'
            })
        }
    },
    mounted() {
        this.getStats()
    }
}
</script>

<style>
    .stats {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 20px;
    }
    .homeinterativa{
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>